export enum LoggingType {
  INFO,
  WARN,
  ERROR,
}

export function log(message: string, type?: LoggingType): void {
  //if (process.env.NODE_ENV !== 'production') {
  switch (type) {
    case LoggingType.ERROR: {
      console.error(message);
      break;
    }
    case LoggingType.WARN: {
      console.warn(message);
      break;
    }
    default: {
      console.log(message);
    }
  }
  //}
}
